import { useState } from "react";
import Sidebar from "../components/Sidebar";
import "./MainLayout.css";

function MainLayout({ children }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="app-layout">
      {/* Mobile Header - Only visible on small screens */}
      <header className="mobile-header">
        <div className="mobile-logo-group">
          <div className="mobile-logo-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <span className="mobile-app-title">ERP System</span>
        </div>
        <button
          className="hamburger-btn"
          onClick={() => setIsMobileMenuOpen(true)}
          aria-label="Open Menu"
        >
          ☰
        </button>
      </header>

      {/* Sidebar with mobile toggle props */}
      <Sidebar
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
      />

      {/* Overlay for mobile sidebar */}
      {isMobileMenuOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
      )}

      <main className="page-content">
        {children}
      </main>
    </div>
  );
}

export default MainLayout;
